/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {localeManager} from "language";

// Localize a date from UTC to the client timezone.
export default function localizeDate({date, format = "LLLL"}) {
  return localeManager.formatDate(
    date,
    {
      format,
      output: "object",
    },
  );
}



// WEBPACK FOOTER //
// ../datetime/localizeDate.js